// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"76089b95","2937":"76089b95","8005":"b21dbeef"}[chunkId] + ".chunk.css";
};